
import React, { Component } from 'react';
class Loading extends Component {
    render() {
        return (
             <div className="error-body1 text-center1" style={{paddingLeft:'40%'}}>
               <img src='../static/assets/images/loading3.gif' width="150"/> </div>

            );
    }
}

export default Loading;